import type { RouteObject } from 'react-router-dom'
import { AppShell } from './AppShell'
import { pageRoutes } from './pageRoutes'
import { OAuthCallback } from '../pages/OAuthCallback'
import { AccessDenied } from '../pages/AccessDenied'
import { LoginRoute } from './LoginRoute'
import { SelectAccountRoute } from './SelectAccountRoute'
import { AUTH_PATHS } from '../lib/routes'

// The page route table (scheme, redirects, not-found) lives in pageRoutes.tsx.
// These top-level routes carry explicit ids: pageRoutes comes out of
// createRoutesFromElements with tree-path ids ("0-0", "0-1", …), and a second
// createRoutesFromElements call here would mint the same ids again — a data
// router refuses duplicate route ids ("Found a route id collision") and the
// whole app fails to start.
export const appRoutes: RouteObject[] = [
  // Auth routes — outside the AppShell guard so they render without a session
  { id: 'oauth-callback', path: AUTH_PATHS.oauthCallback, element: <OAuthCallback /> },
  { id: 'access-denied', path: AUTH_PATHS.accessDenied, element: <AccessDenied /> },
  // Cognito sign-in (MS-977): the Login screen at its own path, and the
  // post-login account choice, which runs on the pending-login cookie.
  { id: 'login', path: AUTH_PATHS.login, element: <LoginRoute /> },
  { id: 'select-account', path: AUTH_PATHS.selectAccount, element: <SelectAccountRoute /> },
  { id: 'shell', element: <AppShell />, children: pageRoutes },
]
